"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScryptEncrypter = void 0;
var scryptEncryption_1 = require("../Helpers/scryptEncryption");
var NAME = "ScryptEncrypter";
/**
 * Encrypt keys with scrypt, as they are on StellarX.com.
 */
exports.ScryptEncrypter = {
    name: NAME,
    encryptKey: function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var key, password, privateKey, path, extra, publicKey, type, props, _a, encryptedPhrase, salt;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        key = params.key, password = params.password;
                        privateKey = key.privateKey, path = key.path, extra = key.extra, publicKey = key.publicKey, type = key.type, props = __rest(key, ["privateKey", "path", "extra", "publicKey", "type"]);
                        return [4 /*yield*/, (0, scryptEncryption_1.encrypt)({
                                password: password,
                                phrase: JSON.stringify({ privateKey: privateKey, path: path, extra: extra, publicKey: publicKey, type: type }),
                            })];
                    case 1:
                        _a = _b.sent(), encryptedPhrase = _a.encryptedPhrase, salt = _a.salt;
                        return [2 /*return*/, __assign(__assign({}, props), { encryptedBlob: encryptedPhrase, encrypterName: NAME, salt: salt })];
                }
            });
        });
    },
    decryptKey: function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var encryptedKey, password, encrypterName, salt, encryptedBlob, props, data, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        encryptedKey = params.encryptedKey, password = params.password;
                        encrypterName = encryptedKey.encrypterName, salt = encryptedKey.salt, encryptedBlob = encryptedKey.encryptedBlob, props = __rest(encryptedKey, ["encrypterName", "salt", "encryptedBlob"]);
                        _b = (_a = JSON).parse;
                        return [4 /*yield*/, (0, scryptEncryption_1.decrypt)({ phrase: encryptedBlob, salt: salt, password: password })];
                    case 1:
                        data = _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/, __assign(__assign({}, props), data)];
                }
            });
        });
    },
};
